export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_02.c9855d96.jpg";